module.exports = __webpack_public_path__ + "img/xk1.c219f838.png";